"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { KNOWN_CHAINS } from "@intents-explorer/shared-api/chains";
import { chainLabel, getLetterIcon } from "@intents-explorer/shared-api/tokens";
import { cn } from "../lib/cn";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";
export function ChainIcon(t0) {
  const $ = _c(22);
  const {
    chain,
    className
  } = t0;
  const {
    theme,
    systemTheme
  } = useTheme();
  const [chainIcon, setChainIcon] = useState(KNOWN_CHAINS[chain]?.icon);
  let t1;
  let t2;
  if ($[0] !== chain || $[1] !== systemTheme || $[2] !== theme) {
    t1 = () => {
      setChainIcon(theme === "dark" || theme === "system" && systemTheme === "dark" ? KNOWN_CHAINS[chain]?.icon : KNOWN_CHAINS[chain]?.iconDark);
    };
    t2 = [chain, systemTheme, theme];
    $[0] = chain;
    $[1] = systemTheme;
    $[2] = theme;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (chain === "") {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <></>;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t3;
  if ($[6] !== chain || $[7] !== chainIcon) {
    t3 = chainIcon === undefined || chainIcon === "" ? getLetterIcon(chainLabel(chain)) : chainIcon;
    $[6] = chain;
    $[7] = chainIcon;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const src = t3;
  let t4;
  if ($[9] !== className) {
    t4 = cn("h-4 w-4", className);
    $[9] = className;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== chain || $[12] !== src || $[13] !== t4) {
    t5 = <TooltipTrigger asChild={true}><Image className={t4} width={16} height={16} src={src} alt={chain} /></TooltipTrigger>;
    $[11] = chain;
    $[12] = src;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== chain) {
    t6 = chainLabel(chain);
    $[15] = chain;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t6) {
    t7 = <TooltipContent>{t6}</TooltipContent>;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t5 || $[20] !== t7) {
    t8 = <Tooltip>{t5}{t7}</Tooltip>;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}